import {
  Box,
  Typography,
  Switch,
  Select,
  MenuItem,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  toggleGenderBalanceMode,
  toggleGenderRestrictedMode,
  setFemalesPerTeam,
} from 'redux/slices';

export function GenderBalanceToggle() {
  const {
    genderBalanceMode, genderRestrictedMode, femalesPerTeam,
  } = useSelector((state) => state.game);
  const dispatch = useDispatch();

  const femaleOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography>Equilíbrio de gênero</Typography>
        <Switch
          checked={genderBalanceMode}
          onChange={() => dispatch(toggleGenderBalanceMode())}
          size="small"
        />
      </Box>
      {genderBalanceMode && (
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body2">Modo restrito</Typography>
          <Switch
            checked={genderRestrictedMode}
            onChange={() => dispatch(toggleGenderRestrictedMode())}
            size="small"
          />
        </Box>
      )}
      {genderBalanceMode && genderRestrictedMode && (
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body2">Mulheres por time</Typography>
          <Select
            value={femalesPerTeam}
            size="small"
            onChange={(e) => dispatch(setFemalesPerTeam(e.target.value))}
          >
            {femaleOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
    </Box>
  );
}
